export const envConfigForShare = {
  prod: {
    policyServiceUrl: 'https://health-policy-service.internal.live.acko.com/health/policy-details',
    proposalServiceUrl: 'https://life-proposal-service.internal.ackolife.com/life/api/v1/proposals',
    healthProposalServiceUrl:
      'https://health-rap-manager-service-prod.internal.live.acko.com/proposals/filter/v2?internal_call=true',
  },
  master: {
    policyServiceUrl: 'https://health-policy-service-uat.internal.ackodev.com/health/policy-details',
    proposalServiceUrl: 'https://life-proposal-builder.internal.ackodev.com/life/api/v1/proposals',
    healthProposalServiceUrl:
      'https://health-rap-manager-service-uat.internal.ackodev.com/proposals/filter/v2?internal_call=true',
  },
  dev: {
    policyServiceUrl: 'https://health-policy-service-uat.internal.ackodev.com/health/policy-details',
    proposalServiceUrl: 'https://life-proposal-builder.internal.ackodev.com/life/api/v1/proposals',
    healthProposalServiceUrl:
      'https://health-rap-manager-service-uat.internal.ackodev.com/proposals/filter/v2?internal_call=true',
  },
  local: {
    policyServiceUrl: 'https://health-policy-service-uat.internal.ackodev.com/health/policy-details',
    proposalServiceUrl: 'https://life-proposal-builder.internal.ackodev.com/life/api/v1/proposals',
    healthProposalServiceUrl:
      'https://health-rap-manager-service-uat.internal.ackodev.com/proposals/filter/v2?internal_call=true',
  },
}
